import React from 'react';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const countDecimalsInString = value => {
  if (!value.includes('.')) return 0;

  return value.split('.')[1].length || 0;
};

const TextMask = props => {
  const { inputRef, ...other } = props;
  const precision = countDecimalsInString(props.value);

  let numberMask = createNumberMask({
    prefix: '',
    allowDecimal: precision > 0,
    decimalLimit: precision,
    allowNegative: true,
    includeThousandsSeparator: false,
  });

  return <MaskedInput {...other} ref={inputRef} mask={numberMask} guide={false} showMask />;
};

TextMask.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export default TextMask;
